<template>
  <Modal :mask-closable="false" v-model="show" :title="title" :width="500">
    <table class="QHtable">
      <tr>
        <td style="width: 120px"><b>年审起止时间</b></td>
        <td>
          <QHdatePicker v-model="form.validityPeriod" fmt="yyyy-MM-dd HH:mm" dayjs="YYYY-MM-DD HH:mm" split-panels type="datetimerange" placeholder="请选择年审起止时间"></QHdatePicker>
        </td>
      </tr>

      <tr>
        <td><b>船舶检验状态</b></td>
        <td>
          <RadioGroup v-model="form.teststatus" size="small">
            <Radio label="100" border>未检验</Radio>
            <Radio label="200" border>已检验</Radio>
          </RadioGroup>
        </td>
      </tr> 

      <tr>
        <td><b>船舶注销状态</b></td>
        <td>
          <RadioGroup v-model="form.cancelstatue" size="small">
            <Radio label="100" border>未注销</Radio>
            <Radio label="200" border>已注销</Radio>
          </RadioGroup>
        </td>
      </tr>

      <tr>
        <td><b>船舶过期状态</b></td>
        <td>
          <RadioGroup v-model="form.expirestatus" size="small">
            <Radio label="100" border>未过期</Radio>
            <Radio label="200" border>已过期</Radio>
          </RadioGroup>
        </td>
      </tr>
    </table>
    <div slot="footer">
      <Button @click="clearFrom()">取消</Button>
      <Button type="primary" @click="saveOk">确定</Button>
    </div>
  </Modal>
</template>

<script>
import data from "./data.js";
export default {
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      title: "船舶信息修改",
      show: false,
      form: { ...data.data },
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:确认提交
    // +----------------------------------------------------------------------
    saveOk() {
      //综合赋值验证
      var parameter = this.$isSubmitValidGetPram(this, data);
      if (!parameter) {
        return;
      }
      parameter.validityPeriodstart = this.form.validityPeriod[0];
      parameter.validityPeriodend = this.form.validityPeriod[1];

      //参数整合与接口
      var that = this;
      var https = {
        isLoading: "isLoadingPop",
        api: this.$api.OSgovShipUpdate,
        parameter: parameter,
        successMsg: "保存成功",
      };

      //请求接口
      var title = "审核确认";
      var msg = "请再次确认审核情况，是否继续吗？";
      this.$confirm({ title: title, msg: msg }, function () {
        that.$httpsApi(https, function (res) {
          that.$emit("success");
          that.clearFrom();
        });
      });
    },

    // +----------------------------------------------------------------------
    // | Desc:唤起新增
    // +----------------------------------------------------------------------
    hiPop(row) {
      this.clearFrom();
      if (this.$isblank(row)) {
        this.$msg("船舶信息丢失请刷新浏览器重新尝试");
        return;
      }
      if (!this.$isblank(row.validityPeriodstart) && !this.$isblank(row.validityPeriodend)) {
        var validityPeriod = [row.validityPeriodstart, row.validityPeriodend];
      }else{
        validityPeriod = [];
      };
      this.form = {
        id: row.id,
        validityPeriod: validityPeriod,
        teststatus: row.teststatus,
        cancelstatue: row.cancelstatue,
        expirestatus: row.expirestatus,
      };
      this.show = true;
    },

    // +----------------------------------------------------------------------
    // | Desc:清理表单
    // +----------------------------------------------------------------------
    clearFrom() {
      this.show = false;
      this.form = { ...data.data };
    },
  },
};
</script>
